'use strict';

// Libraries
import React from 'react';
import { Manager, Target } from 'react-popper';
import outy from 'outy';
import bowser from 'bowser';

// Components
import BadgeItem from '../BadgeItem';
import Tooltip, { TooltipTheme } from 'ck-core-client/source/components/Tooltip';
import BadgesTooltipContent from '../BadgesTooltipContent';
export default class BadgesItemToolTip extends React.Component {
	state = {
		isOpen: false
	};

	componentDidMount() {
		const elements = [this._tooltipRef];
		const types = ['click', 'touchstart'];
		this.outsideClick = outy(elements, types, this.handleOutsideTap);
	}

	handleOutsideTap = () => {
		this.setState({
			isOpen: false
		});
	};

	handleShowTooltip = method => {
		if ((method === 'click' && bowser.mobile) || method === 'hover') {
			this.setState({ isOpen: true });
		}
	};
	componentWillUnmount() {
		this.outsideClick.remove();
	}

	render() {
		const { isOpen } = this.state;
		const { badge, showTooltip, handleClick } = this.props;
		return (
			<div
				className="BadgeItemTooltip"
				ref={tooltip => (this._tooltipRef = tooltip)}
				onMouseOver={() => showTooltip && this.handleShowTooltip('hover')}
				onMouseLeave={() => showTooltip && this.setState({ isOpen: false })}
				onClick={() => showTooltip && this.handleShowTooltip('click')}
			>
				<Manager className="BadgeItemTooltip__manager">
					<Target className="BadgeItemTooltip__target">
						<BadgeItem
							{...this.props}
							{...badge}
							handleClick={() => {
								handleClick && handleClick(badge);
							}}
						/>
					</Target>
					<Tooltip isOpen={isOpen} theme={TooltipTheme.BlueMaze}>
						<BadgesTooltipContent badge={badge} key={badge.badgeId} />
					</Tooltip>
				</Manager>
			</div>
		);
	}
}
